import React, { useRef, useState } from "react";

import { Uploader } from "@hedgefund/shared";
import { Col } from "antd";
import { Input } from "@public/ui-toolkit";

const SendMessageForm = ({ sendMessage, uploadFiles, isChatToggle }) => {
  const [message, setMessage] = useState("");
  const [fileState, setFileState] = useState([]);
  const [fileMode, setFileMode] = useState(false);
  const sendMessageEl = useRef();

  const toggleFileSection = () => {
    setFileMode(!fileMode);
  };
  const onFileChange = ({ meta, file }, allFiles, status) => {
    setFileState([...fileState, meta]);

    setFileState(status);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (fileMode) {
      setFileState(e.target.files);
      const formData = new FormData();
      formData.append("Message", message);
      for (let i = 0; i < fileState?.length; i++) {
        formData.append(`Files`, fileState[i].file);
      }
      uploadFiles(formData);
      setMessage("");
      setFileState([]);
      toggleFileSection();
    } else {
      sendMessage(message);
      setMessage("");
    }
    // const data = {
    //   sendMessageValue: sendMessageEl.current.value,
    // };
  };
  return (
    <form
      onSubmit={handleSubmit}
      style={{
        border: "1px solid #ccc",
        // borderRadius : "10%",
        flexDirection: fileMode ? "column" : "row",
      }}
    >
      {fileMode ? <Uploader onFileChange={onFileChange} /> : ""}
      {/* <Input size="large" placeholder="large size" prefix={<UserOutlined />} /> */}

      <Input
       addonAfter
        type="text"
        placeHolder="message..."
        label={message ? "" : "message..."}
        forr="message"
        inputRef={sendMessageEl}
        onChange={(e) => setMessage(e.target.value)}
        value={message}
        disabled={isChatToggle}
      />
      <Col className="message-actions">
        <button
          type="button"
          className="send-msg-btn"
          style={{ border: "0px", background: "transparent" }}
          onClick={toggleFileSection}
          disabled={isChatToggle}
        >
          <img src="./assets/images/attachment-icon.svg" alt="icon" />
        </button>
        <button
          type="submit"
          className="send-msg-btn"
          style={{ border: "0px", background: "transparent" }}
          disabled={!message && fileState.length == 0}
        >
          <img
            src="./assets/images/send-icon.svg"
            alt="icon"
            onSubmit={handleSubmit}
          />
        </button>
      </Col>
    </form>
  );
};

export default SendMessageForm;
